// component name const
const COMPONENT_NAME_MAPPER = {
  calendarMaster: 'calendarmaster', // 営業カレンダーマスタ
  menuFileStorage: 'menufilestrage', // ファイルストレージ
};

export default COMPONENT_NAME_MAPPER;
